import { useState } from "react";
import { Link } from "react-router-dom";

// ── DEMO DATA — baad mein backend se replace hoga ──
const demoEnquiries = {
  "ECO-2026-001": {
    id: "ECO-2026-001",
    email: "demo@example.com",
    name: "Rahul Sharma",
    subject: "AC EV Charger 7.4kW",
    category: "Chargers & Inverters",
    message: "Need 10 units for our parking facility in Gurugram.",
    submittedAt: "13 May 2026, 10:30 AM",
    status: "contacted",
    timeline: [
      { step: "submitted", label: "Enquiry Submitted", date: "13 May 2026, 10:30 AM", done: true },
      { step: "review", label: "Under Review", date: "13 May 2026, 11:00 AM", done: true },
      { step: "contacted", label: "Our Team Contacted You", date: "13 May 2026, 2:00 PM", done: true },
      { step: "resolved", label: "Resolved", date: null, done: false },
    ],
  },
  "ECO-2026-002": {
    id: "ECO-2026-002",
    email: "test@gmail.com",
    name: "Priya Singh",
    subject: "Solar Panel 400W Mono PERC",
    category: "Solar Panels & Pumps",
    message: "Looking for 50 panels for rooftop solar project.",
    submittedAt: "14 May 2026, 9:00 AM",
    status: "review",
    timeline: [
      { step: "submitted", label: "Enquiry Submitted", date: "14 May 2026, 9:00 AM", done: true },
      { step: "review", label: "Under Review", date: "14 May 2026, 9:30 AM", done: true },
      { step: "contacted", label: "Our Team Contacted You", date: null, done: false },
      { step: "resolved", label: "Resolved", date: null, done: false },
    ],
  },
};

const statusConfig = {
  submitted: { color: "#1e4d8c", bg: "#eaf0fb", label: "Submitted" },
  review: { color: "#8a5a0f", bg: "#faf3e5", label: "Under Review" },
  contacted: { color: "#2d6a4f", bg: "#eaf4ef", label: "Team Contacted" },
  resolved: { color: "#4a3580", bg: "#f0ecfb", label: "Resolved" },
};

const stepIcons = {
  submitted: "📋",
  review: "🔍",
  contacted: "📞",
  resolved: "✅",
};

function EnquiryResult({ enquiry }) {
  const status = statusConfig[enquiry.status];

  return (
    <div style={{
      background: "white", borderRadius: "18px",
      border: "1.5px solid #e8eaed",
      overflow: "hidden",
      boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
      animation: "fadeUp 0.3s ease",
    }}>
      {/* Header */}
      <div style={{
        background: status.bg,
        padding: "24px 28px",
        borderBottom: `2px solid ${status.color}20`,
        display: "flex", alignItems: "center",
        justifyContent: "space-between", flexWrap: "wrap", gap: "12px",
      }}>
        <div>
          <div style={{
            fontSize: "11px", fontWeight: "800",
            color: status.color, letterSpacing: "1px",
            textTransform: "uppercase",
            fontFamily: "'Sora', sans-serif",
            marginBottom: "6px",
          }}>
            ENQUIRY ID: {enquiry.id}
          </div>
          <h3 style={{
            fontFamily: "'Sora', sans-serif",
            fontSize: "18px", fontWeight: "900",
            color: "#1a1a2e", margin: 0,
          }}>
            {enquiry.subject}
          </h3>
          <p style={{
            fontSize: "13px", color: "#6b7280",
            fontFamily: "'DM Sans', sans-serif",
            margin: "4px 0 0",
          }}>
            {enquiry.category} • Submitted {enquiry.submittedAt}
          </p>
        </div>

        <div style={{
          display: "inline-flex", alignItems: "center", gap: "7px",
          background: "white",
          color: status.color,
          fontSize: "12px", fontWeight: "700",
          padding: "8px 18px", borderRadius: "20px",
          fontFamily: "'Sora', sans-serif",
          border: `1.5px solid ${status.color}30`,
          boxShadow: `0 2px 8px ${status.color}15`,
        }}>
          <div style={{
            width: "7px", height: "7px", borderRadius: "50%",
            background: status.color,
          }} />
          {status.label}
        </div>
      </div>

      {/* Timeline */}
      <div style={{ padding: "28px 28px 20px" }}>
        <h4 style={{
          fontFamily: "'Sora', sans-serif",
          fontSize: "13px", fontWeight: "800",
          color: "#9ca3af", letterSpacing: "1.5px",
          textTransform: "uppercase", marginBottom: "24px",
        }}>
          TRACKING TIMELINE
        </h4>

        <div style={{ position: "relative" }}>
          {/* Vertical line */}
          <div style={{
            position: "absolute", left: "19px", top: "8px",
            width: "2px",
            height: `calc(100% - 32px)`,
            background: "#e8eaed",
            zIndex: 0,
          }} />

          {enquiry.timeline.map((step, i) => (
            <div key={i} style={{
              display: "flex", gap: "16px", alignItems: "flex-start",
              marginBottom: i < enquiry.timeline.length - 1 ? "20px" : "0",
              position: "relative", zIndex: 1,
            }}>
              {/* Circle */}
              <div style={{
                width: "40px", height: "40px", borderRadius: "50%",
                background: step.done ? status.color : "#f3f4f6",
                border: `2px solid ${step.done ? status.color : "#e5e7eb"}`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "16px", flexShrink: 0,
                boxShadow: step.done ? `0 4px 12px ${status.color}25` : "none",
                transition: "all 0.3s ease",
              }}>
                {step.done
                  ? <span style={{ fontSize: "16px" }}>{stepIcons[step.step]}</span>
                  : <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#d1d5db" }} />
                }
              </div>

              {/* Content */}
              <div style={{ paddingTop: "8px", flex: 1 }}>
                <div style={{
                  fontFamily: "'Sora', sans-serif",
                  fontSize: "14px", fontWeight: "700",
                  color: step.done ? "#1a1a2e" : "#9ca3af",
                }}>
                  {step.label}
                </div>
                {step.date && (
                  <div style={{
                    fontSize: "12px", color: "#9ca3af",
                    fontFamily: "'DM Sans', sans-serif",
                    marginTop: "3px",
                  }}>
                    {step.date}
                  </div>
                )}
                {!step.done && (
                  <div style={{
                    fontSize: "11px", color: "#c4c9d4",
                    fontFamily: "'DM Sans', sans-serif",
                    marginTop: "3px", fontStyle: "italic",
                  }}>
                    Pending...
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Enquiry Details */}
      <div style={{
        padding: "20px 28px 28px",
        borderTop: "1px solid #f3f4f6",
      }}>
        <h4 style={{
          fontFamily: "'Sora', sans-serif",
          fontSize: "13px", fontWeight: "800",
          color: "#9ca3af", letterSpacing: "1.5px",
          textTransform: "uppercase", marginBottom: "16px",
        }}>
          ENQUIRY DETAILS
        </h4>
        <div style={{
          background: "#f8fafc", borderRadius: "12px",
          padding: "16px 20px",
          border: "1px solid #edeef0",
        }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
            <div>
              <div style={{ fontSize: "11px", color: "#9ca3af", fontFamily: "'DM Sans', sans-serif", marginBottom: "3px" }}>NAME</div>
              <div style={{ fontSize: "14px", fontWeight: "600", color: "#1a1a2e", fontFamily: "'DM Sans', sans-serif" }}>{enquiry.name}</div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9ca3af", fontFamily: "'DM Sans', sans-serif", marginBottom: "3px" }}>CATEGORY</div>
              <div style={{ fontSize: "14px", fontWeight: "600", color: "#1a1a2e", fontFamily: "'DM Sans', sans-serif" }}>{enquiry.category}</div>
            </div>
          </div>
          <div style={{ marginTop: "12px" }}>
            <div style={{ fontSize: "11px", color: "#9ca3af", fontFamily: "'DM Sans', sans-serif", marginBottom: "3px" }}>MESSAGE</div>
            <div style={{ fontSize: "14px", color: "#374151", fontFamily: "'DM Sans', sans-serif", lineHeight: "1.6" }}>{enquiry.message}</div>
          </div>
        </div>
      </div>

      {/* Help */}
      <div style={{
        padding: "16px 28px",
        background: "#f8fafc",
        borderTop: "1px solid #f0f0f0",
        display: "flex", alignItems: "center",
        justifyContent: "space-between", flexWrap: "wrap", gap: "10px",
      }}>
        <span style={{ fontSize: "13px", color: "#6b7280", fontFamily: "'DM Sans', sans-serif" }}>
          Need help? Contact our team
        </span>
        <Link to="/contact" style={{ textDecoration: "none" }}>
          <button style={{
            background: "#2d6a4f", color: "white",
            border: "none", borderRadius: "8px",
            padding: "8px 20px", fontSize: "13px",
            fontWeight: "700", cursor: "pointer",
            fontFamily: "'Sora', sans-serif",
          }}>
            Contact Support
          </button>
        </Link>
      </div>
    </div>
  );
}

function MyEnquiries() {
  const [email, setEmail] = useState("");
  const [enquiryId, setEnquiryId] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleTrack = () => {
    setError("");
    setResult(null);

    if (!email || !enquiryId) {
      setError("Please enter both Email and Enquiry ID.");
      return;
    }

    setLoading(true);

    // Simulate API call
    setTimeout(() => {
      const found = demoEnquiries[enquiryId.toUpperCase()];
      if (found && found.email.toLowerCase() === email.toLowerCase()) {
        setResult(found);
      } else {
        setError("No enquiry found. Please check your Email and Enquiry ID.");
      }
      setLoading(false);
    }, 800);
  };

  return (
    <main style={{ background: "#f8fafc", minHeight: "100vh" }}>

      {/* HERO */}
      <div style={{
        background: "white",
        borderBottom: "1px solid #e8eaed",
        padding: "48px 56px 40px",
      }}>
        <div style={{ maxWidth: "680px", margin: "0 auto", textAlign: "center" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "8px",
            background: "#eaf4ef", color: "#2d6a4f",
            fontSize: "11px", fontWeight: "800",
            padding: "6px 16px", borderRadius: "7px",
            fontFamily: "'Sora', sans-serif",
            letterSpacing: "0.9px", textTransform: "uppercase",
            marginBottom: "20px",
            border: "1.5px solid #c2ddd0",
          }}>
             Track Your Enquiry
          </div>

          <h1 style={{
            fontFamily: "'Sora', sans-serif",
            fontSize: "clamp(24px, 3vw, 36px)",
            fontWeight: "900", color: "#1a1a2e",
            margin: "0 0 12px", letterSpacing: "-0.8px",
          }}>
            My Enquiries
          </h1>
          <p style={{
            fontSize: "15.5px", color: "#6b7280",
            fontFamily: "'DM Sans', sans-serif",
            lineHeight: "1.7", margin: 0,
          }}>
            Enter your registered email and Enquiry ID to track your enquiry status in real time.
          </p>
        </div>
      </div>

      {/* FORM */}
      <div style={{ maxWidth: "680px", margin: "40px auto", padding: "0 24px" }}>

        {/* Search Card */}
        <div style={{
          background: "white", borderRadius: "18px",
          border: "1.5px solid #e8eaed",
          padding: "32px 36px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
          marginBottom: "24px",
        }}>
          <h2 style={{
            fontFamily: "'Sora', sans-serif",
            fontSize: "17px", fontWeight: "900",
            color: "#1a1a2e", margin: "0 0 24px",
          }}>
             Track Enquiry
          </h2>

          {/* Email */}
          <div style={{ marginBottom: "16px" }}>
            <label style={{
              display: "block", fontSize: "12px",
              fontWeight: "700", color: "#374151",
              fontFamily: "'Sora', sans-serif",
              marginBottom: "8px", letterSpacing: "0.3px",
            }}>
              EMAIL ADDRESS *
            </label>
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%", padding: "12px 16px",
                border: "1.5px solid #e5e7eb",
                borderRadius: "10px", fontSize: "14px",
                fontFamily: "'DM Sans', sans-serif",
                outline: "none", transition: "border-color 0.2s",
                background: "#fafafa",
              }}
              onFocus={(e) => e.target.style.borderColor = "#2d6a4f"}
              onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
            />
          </div>

          {/* Enquiry ID */}
          <div style={{ marginBottom: "24px" }}>
            <label style={{
              display: "block", fontSize: "12px",
              fontWeight: "700", color: "#374151",
              fontFamily: "'Sora', sans-serif",
              marginBottom: "8px", letterSpacing: "0.3px",
            }}>
              ENQUIRY ID *
            </label>
            <input
              type="text"
              placeholder="e.g. ECO-2026-001"
              value={enquiryId}
              onChange={(e) => setEnquiryId(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleTrack()}
              style={{
                width: "100%", padding: "12px 16px",
                border: "1.5px solid #e5e7eb",
                borderRadius: "10px", fontSize: "14px",
                fontFamily: "'DM Sans', sans-serif",
                outline: "none", transition: "border-color 0.2s",
                background: "#fafafa",
              }}
              onFocus={(e) => e.target.style.borderColor = "#2d6a4f"}
              onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
            />
            <p style={{
              fontSize: "11.5px", color: "#9ca3af",
              fontFamily: "'DM Sans', sans-serif",
              margin: "6px 0 0",
            }}>
               Enquiry ID is sent to your email after submitting an enquiry
            </p>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              background: "#fef2f2", border: "1px solid #fecaca",
              borderRadius: "10px", padding: "12px 16px",
              marginBottom: "16px",
              display: "flex", alignItems: "center", gap: "8px",
            }}>
              <span style={{ fontSize: "16px" }}>⚠️</span>
              <span style={{ fontSize: "13.5px", color: "#dc2626", fontFamily: "'DM Sans', sans-serif" }}>{error}</span>
            </div>
          )}

          {/* Track Button */}
          <button
            onClick={handleTrack}
            disabled={loading}
            style={{
              width: "100%", padding: "14px",
              background: loading ? "#9ca3af" : "#2d6a4f",
              color: "white", border: "none",
              borderRadius: "10px", fontSize: "15px",
              fontWeight: "700", cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "'Sora', sans-serif",
              transition: "all 0.18s ease",
              boxShadow: loading ? "none" : "0 6px 20px rgba(45,106,79,0.3)",
            }}
            onMouseEnter={(e) => { if (!loading) e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
          >
            {loading ? " Searching..." : "Track My Enquiry →"}
          </button>
        </div>

        {/* Result */}
        {result && <EnquiryResult enquiry={result} />}

        {/* New Enquiry CTA */}
        <div style={{
          textAlign: "center", marginTop: "32px",
          padding: "24px", background: "white",
          borderRadius: "14px", border: "1.5px solid #e8eaed",
        }}>
          <p style={{
            fontSize: "14px", color: "#6b7280",
            fontFamily: "'DM Sans', sans-serif", marginBottom: "14px",
          }}>
            Don't have an enquiry yet?
          </p>
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <button style={{
              background: "#eaf4ef", color: "#2d6a4f",
              border: "1.5px solid #c2ddd0",
              borderRadius: "10px", padding: "11px 28px",
              fontSize: "14px", fontWeight: "700",
              cursor: "pointer", fontFamily: "'Sora', sans-serif",
              transition: "all 0.18s ease",
            }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#2d6a4f"; e.currentTarget.style.color = "white"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "#eaf4ef"; e.currentTarget.style.color = "#2d6a4f"; }}
            >
              Submit New Enquiry →
            </button>
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </main>
  );
}

export default MyEnquiries;